import { axiosInstance as request } from '@api/rest.service'

const api = subscriptionId => `/subscriptions/${subscriptionId}/license-periods`

/**
 * @description GET /subscriptions/${subscriptionId}/license-periods
 * @returns {AxiosPromise<any>}
 */
export const GET_SUBSCRIPTION_LICENSE_PERIODS = subscriptionId => request.get(api(subscriptionId))

/**
 * @description PUT /subscriptions/${subscriptionId}/license-periods
 * @returns {AxiosPromise<any>}
 */
export const UPDATE_SUBSCRIPTION_LICENSE_PERIODS = (subscriptionId, payload) =>
  request.put(api(subscriptionId), payload)

/**
 * @description GET /subscriptions/${subscriptionId}/license-periods/available
 * @returns {AxiosPromise<any>}
 */
export const GET_SUBSCRIPTION_LICENSE_PERIODS_AVAILABLE = subscriptionId =>
  request.get(`${api(subscriptionId)}/available`)
